import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Marcas } from '../_model/marcas';
import { Produtos } from '../_model/produtos';
import { Tipo } from '../_model/tipo';
import { MarcasService } from '../_services/marcas.service';
import { ProdutosService } from '../_services/produtos.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
    selector: 'app-gestao',
    templateUrl: './gestao.component.html',
    styleUrls: ['./gestao.component.less'],
    standalone: false
})
export class GestaoComponent implements OnInit {

  constructor(private prod: ProdutosService, private marca: MarcasService) { }

  produtos: Produtos[] = [];
  queryM: boolean = false;
  query: string = "";
  savedProds: Produtos[] = [];
  links: any[] = [{link: 'admin', name: 'Administração'}];
  marcas: Marcas[] = [];
  savedMarcas: Marcas[] = [];

  tipo: Tipo[] = [

    new Tipo({
      key: "alta",
      name: "Alta Relojoaria"
    }),
    new Tipo({
      key: "relogio",
      name: "Relojoaria"
    }),
    new Tipo({
      key: "j1",
      name: "Joalharia"
    }),
    new Tipo({
      key: "j2",
      name: "Pratas"
    }),
    new Tipo({
      key: "acess",
      name: "Acessórios"
    }),
    new Tipo({
      key: 'noiva',
      name: 'Noivas'
    })
  ];

  ngOnInit() {
    this.prod.list().subscribe((data: any) => {
      data.forEach(el => {
        this.produtos.push(new Produtos(el));
        this.savedProds.push(new Produtos(el));
      });
    });
    this.marca.list().subscribe((data: any[]) => {
      data.forEach(el => {
        this.marcas.push(new Marcas(el));
        this.savedMarcas.push(new Marcas(el));
      });
    });
  }

  search() {
    if(this.queryM) {
      this.marcas = this.savedMarcas.filter(x => x.nome.toLowerCase().includes(this.query.toLowerCase()));
      var temp: Produtos[] = [];
      this.marcas.forEach(it => {
        this.savedProds.filter(x => x.marcasId == it.id).forEach(it2 => {
          temp.push(it2);
        });
      });
      this.produtos = temp;
    }else{
      this.produtos = this.savedProds.filter(x => x.nome.toLowerCase().includes(this.query.toLowerCase()) || x.ref.toLowerCase().includes(this.query.toLowerCase()));
    }
  }

  exportExcel() {
    var ex: exportTemplate[] = [];
    var i: number = 1;
    this.produtos.forEach(el => {
      var temp: exportTemplate = new exportTemplate();
      temp.Numeração = i++;
      temp.Categoria = this.getTipo(el.tipo);
      temp.Marca = this.getMarca(el);
      temp.Modelo = el.nome;
      temp.Referência = el.ref;
      ex.push(temp);
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ex);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, 'export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  exportPdf(opt: boolean) {
    var ex: any[] = [];
    var i: number = 1;
    this.produtos.forEach(el => {
      var temp: any[] = [
        i++,
        this.getTipo(el.tipo),
        this.getMarca(el),
        el.nome,
        el.ref
      ];
      ex.push(temp);
    });
    var pdf = new jsPDF();
    pdf.setFontSize(18);
    pdf.text('', 11, 8);
    pdf.setFontSize(11);
    pdf.setTextColor(100);
    (pdf as any).autoTable({
      head: [['#','Categoria', 'Marca', 'Modelo', 'Referência']],
      body: ex,
      theme: 'striped',
      didDrawCell: data => {
      }
    });
    if(opt)
      pdf.save('export_' + new Date().getTime() + '.pdf');
    else {
      pdf.autoPrint();
      pdf.output("dataurlnewwindow"); 
    }   
  }

  getMarca(item: Produtos) {
    if(item?.marcasId && this.marcas?.length){
      return this.marcas.filter(x => x.id == item.marcasId)[0].nome;
    }
    return "";
  }

  getTipo(item: string) {
    return this.tipo.filter(x => x.key == item.split(";")[0])[0].name;
  }

  filterType(it: string) {
    this.produtos = this.savedProds.filter(x => x.tipo.toLowerCase().includes(it.toLowerCase()));
  }

  delete(item: Produtos) {
    Swal.fire({
      title: "Tem a certeza que pretende eliminar o produto?",
      text: "Se continuar com esta ação ira eliminar "+item.nome+" da base de dados",
      icon: 'warning',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      customClass: {
        confirmButton: "btn red base",
        cancelButton: "btn green base"
      }
    }).then((result) => {
      if(result.isConfirmed) {
        Swal.fire({
          title: "Produto Eliminado com sucesso",
          text: "O produto "+item.nome+" foi eliminado da base de dados",
          icon: 'success'
        });
        this.prod.delete(item.id, localStorage.getItem("userId")).subscribe(() => {          
          this.prod.list().subscribe((data: any) => {
            this.produtos = [];
            data.forEach(el => {
              this.produtos.push(new Produtos(el));
            });
          });
        });
      }
    });
  }

}

class exportTemplate {
  Numeração: number ;
  Categoria: string;
  Marca: string;
  Modelo: string;
  Referência: string;
}
